<template>
    <div class="cabinet-content-wrap">
        <SearchAndBasket />

        <section class="cabinet__breadcrumbs">
            <router-link to="/" class="cabinet__breadcrumbs-link"
                >Главная</router-link
            >
            <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
            <router-link to="/catalog" class="cabinet__breadcrumbs-link"
                >Каталог</router-link
            >
            <span class="cabinet__breadcrumbs-arrow">&rsaquo;</span>
            <a
                v-if="publicSearchGlobal || routeParamsId === 'all'"
                href="javascript:void(0)"
                class="cabinet__breadcrumbs-link"
                >Все изделия</a
            >
            <a
                v-else
                href="javascript:void(0)"
                class="cabinet__breadcrumbs-link"
                >{{ categories2Level ? categories2Level.Name : null }}</a
            >
        </section>

        <div v-if="categories" class="cabinet__product-page">
            <transition name="fade" mode="out-in">
                <h1
                    v-if="!publicSearchGlobal && routeParamsId === 'all'"
                    key="1"
                    class="h1"
                >
                    Все изделия
                </h1>
                <h1 v-else-if="publicSearchGlobal" key="2" class="h1">
                    Поиск по запросу - {{ publicSearchGlobal }}
                </h1>
                <h1 v-else-if="category2LevelActive" key="3" class="h1">
                    {{ filter2subcategories.Name }}
                </h1>
                <h1 v-else key="4" class="h1">
                    {{ categories2Level.Name }}
                </h1>
            </transition>

            <div
                v-if="categories2Level && categories2Level.types.length > 1"
                :class="{ 'is-prev': !isBeginning, 'is-next': !isEnd }"
                class="cabinet__product-page__filters_wrap"
            >
                <div
                    ref="prev"
                    :class="{ quick: !isBeginning, hide: isBeginning }"
                    class="cabinet__product-page__filters-arrow prev"
                >
                    <img src="/img/arrow_forward.svg" alt="" />
                </div>
                <div ref="swiperContainer" class="swiper-container">
                    <div class="cabinet__product-page__filters swiper-wrapper">
                        <div
                            v-for="type in typesCategory2Level"
                            :key="type.TypeID"
                            ref="swiperSlide"
                            class="swiper-slide"
                        >
                            <a
                                href="javascript:void(0)"
                                class="cabinet__product-page__filters-item"
                                :class="{
                                    active: category2LevelActive === type.TypeID
                                }"
                                @click="filtering2Subcategories(type)"
                            >
                                <div
                                    v-if="type.Image"
                                    class="cabinet__product-page__filters-icon"
                                >
                                    <img :src="type.Image" :alt="type.Name" />
                                </div>
                                <span
                                    class="cabinet__product-page__filters-title"
                                    >{{ type.Name }}</span
                                >
                            </a>
                        </div>
                    </div>
                </div>
                <div
                    v-if="isButtonNext"
                    :class="{ quick: !isEnd, hide: isEnd }"
                    class="cabinet__product-page__filters-arrow next"
                >
                    <img src="/img/arrow_forward.svg" alt="" />
                </div>
            </div>

            <brand-products
                ref="product-list"
                :brand="brand"
                :request-for-categories="true"
                :is-category-page="true"
                :filter2subcategories="filter2subcategories"
                @resetFilters="resetFilters"
            />

            <div
                v-if="textForSeo"
                class="cabinet__product-page__note"
                v-html="textForSeo"
            ></div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'

import BrandProducts from '@/components/Public/Brand/Products'
import SearchAndBasket from '@/components/Public/SearchAndBasket'

import vClickOutside from 'v-click-outside'

export default {
    name: 'CategoryID',
    components: {
        BrandProducts,
        SearchAndBasket
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    props: {
        filter2SubcategoriesFromRoute: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            routeParamsId: this.$route.params.id,
            brand: {},
            filter2subcategories: {},
            category2LevelActive: '',
            swiperSlider: null,
            isButtonNext: true
        }
    },
    computed: {
        isBeginning() {
            return this.swiperSlider ? this.swiperSlider.isBeginning : true
        },
        isEnd() {
            return this.swiperSlider ? this.swiperSlider.isEnd : true
        },
        ...mapGetters({
            categories: 'publicCategories',
            publicSearchGlobal: 'publicSearchGlobal'
        }),
        categories2Level() {
            return this.categories
                ? this.categories.filter(
                      el => el.CategoryID == this.$route.params.id
                  )[0]
                : null
        },
        typesCategory2Level() {
            const types = this.categories2Level.types.filter(
                el => el.items_count
            )
            const typesList = types.map(p =>
                p.Position === null ? { ...p, Position: 99999 } : p
            )
            const sortedTypes = typesList.sort((a, b) =>
                a.Position > b.Position ? 1 : b.Position > a.Position ? -1 : 0
            )
            return sortedTypes
        },
        textForSeo() {
            return this.$route.params.id !== 'all'
                ? this.categories.filter(
                      el => el.CategoryID == this.$route.params.id
                  )[0].SEO_text
                : false
        }
    },
    created() {
        if (this.filter2SubcategoriesFromRoute) {
            this.filter2subcategories = this.filter2SubcategoriesFromRoute
            this.category2LevelActive = this.filter2SubcategoriesFromRoute.TypeID
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.swiperSlider = new Swiper('.swiper-container', {
                    slidesPerView: 'auto',
                    mousewheel: {
                        sensitivity: 5,
                        releaseOnEdges: true
                    },
                    navigation: {
                        nextEl: '.next',
                        prevEl: '.prev',
                        disabledClass: 'hide'
                    }
                })

                this.showButtonNext()

                this.swiperSlider.on('resize', () => this.showButtonNext())
            }, 1000)
        })
    },
    beforeRouteEnter(to, from, next) {
        if (from.name !== 'RetailerProductID' && from.name !== 'ProductID') {
            localStorage.removeItem('retailer-catalog-data')
        }

        next()
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'RetailerProductID' || from.name !== 'ProductID') {
            const { filter, search, view, pagination, sort } = this.$refs[
                'product-list'
            ].$children[0]
            const retailerCatalogData = {
                filter,
                search,
                view,
                pagination,
                sort
            }

            localStorage.setItem(
                'retailer-catalog-data',
                JSON.stringify(retailerCatalogData)
            )
        } else {
            localStorage.removeItem('retailer-catalog-data')
        }

        next()
    },
    methods: {
        filtering2Subcategories(type) {
            if (this.category2LevelActive === type.TypeID) {
                this.filter2subcategories = 'reset'
                this.category2LevelActive = ''
            } else {
                this.category2LevelActive = type.TypeID
                this.filter2subcategories = type
            }
        },
        resetFilters() {
            this.category2LevelActive = ''
        },
        showButtonNext() {
            const widthOfAllElements = this.$refs.swiperSlide.reduce(
                (acc, el) => acc + el.clientWidth,
                0
            )

            if (this.$refs.swiperContainer) {
                this.isButtonNext = !(
                    this.$refs.swiperContainer.clientWidth > widthOfAllElements
                )
            }
        }
    }
}
</script>
